<template>
    <div class="papsi-wrapper">
        <div class="papsi-wrapper flex justify-between">
            <div>
                <h1 class="text-2xl font-semibold text-[#24723b]">Consideration Requests</h1>
                <p class="text-xs text-[#747474] mt-2">Home / Consideration Requests</p>
            </div>
            <div>
                <button  class="py-3 px-5 rounded-md text-sm mr-5 w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]" @click="activeBtn = 'Button1'" v-bind:class="{active: activeBtn === 'Button1' , notactive: activeBtn === 'Button2'}">Requests Status</button>
                <button  class="py-3 px-5 rounded-md text-sm  w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]"  @click="activeBtn = 'Button2'" v-bind:class="{active: activeBtn === 'Button2', notactive: activeBtn === 'Button1'}"  >Noted Requests</button>
            </div>
        </div>
    </div>
    <div class="mt-11">
        <div v-if="activeBtn === 'Button1'" class="grid grid-cols-11 w-full gap-3 mb-5 ">
            <input type="text" @input="isTyping = true" placeholder="Search" class="col-span-3 border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm" v-model="search">
            <select @change="consiFilter" class="w-[250px] border-[#b7b8b7] border  rounded-md   outline-none p-2 px-5  text-[#535353]  text-xs font-semibold" v-model="filtered">
                <option value="R">FOR RECOMMENDATION</option>
                <option value="P">FOR APPROVAL</option>
                <option value="A">APPROVED</option>
                <option value="D">DISAPPROVED</option>
                <option value="ALL">ALL</option>
            </select>
        </div>
        <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
            <TableControl v-if="activeBtn === 'Button1'" :Action="true" :header="header" :column="column" :info="info" :VButton="true" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton"/>                
            <TableControl v-if="activeBtn === 'Button2'" :Action="true" :header="header1" :column="columnConsiNoted" :VButton="true" :info="noteconsi" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton"/>                
        </div>
    </div>

    <div v-if="ViewConsideration">
        <ViewConsideration @CloseView="ViewConsideration = false" @cancel="ViewConsideration = false" :Data="Data" :Approval="false" @NoteConsi="NoteConsideration"/>
    </div>



    </template>
    <script>
    import _ from 'lodash';
    import { defineComponent } from 'vue';
    import TableControl from '.././TableControl/TableControl.vue' 
    import ViewConsideration from '../modal/ConsiderFormControl.vue'
    import Services from '../../../services/admin'
    
    export default defineComponent(
    {
        components:{
            TableControl,
            ViewConsideration
        },
        data(){ 
            return{
                isTyping:false,
                search:'',
                filtered: 'ALL',
                ViewConsideration: false,
                info: '',
                activeBtn: "Button1",
                test: '',
                Data:'',
                noteconsi:'',
                AllConsi:'',
                //REQUEST STATUS
                header:[
                    {title:'Request No.'},
                    {title:'Employee Name'},
                    {title:'Date Applied'},
                    {title:'Covered Date'},
                    {title:'Status'},
                    {title:'Action'},                  
                ],

                column:[
                    'consi_no',
                    'employee_name',
                    'date_applied',
                    'covered_date',
                    'con_status',
                ],
                //NOTED REQUEST
                header1:[
                    {title:'Request No.'},
                    {title:'Employee Name'},
                    {title:'Date Applied'},
                    {title:'Covered Date'},
                    {title:'Noted by'},
                    {title:'Action'}, 
                ],
                columnConsiNoted:[
                    'consi_no',
                    'employee_name',
                    'date_applied',
                    'covered_date',
                    'noted_by'
                
                ],
            }
         },
         watch: {
                search: _.debounce(function() {
                this.isTyping = false;
                }, 700),
                isTyping: function(value) {
                if (!value) {
                    this.searchConsi()
                }
                }
        },
        mounted(){
            this.GetConsideration()
            this.getnotedConsideration()
            
        },
        methods:{
            async GetConsideration()
            {
                this.$emit("showLoader")
                const success = await Services.getConsideration(this.search);
                this.AllConsi = success.data
                this.info     = success.data
                this.$emit("hideLoader")
            },
            async searchConsi(){
            const success     = await Services.getConsideration(this.search);
            this.AllConsi   = success.data
            this.info       = success.data
            this.consiFilter()
            },
            consiFilter(){
            if(this.filtered == 'ALL' ){
                this.info = this.AllConsi
                return
            }
            this.info = this.AllConsi.filter(status=>status.con_status == this.filtered)
            },
            async getnotedConsideration()
            {
                this.$emit("showLoader")
                const success = await Services.getnotedConsideration();
                this.noteconsi = success.data
                this.$emit("hideLoader")
            },
            ViewButton(row){
                this.ViewConsideration = true
                this.Data = row
            },
            async NoteConsideration(consi_no){
           
                this.$emit("showLoader")
                let state = this.$store.state
                const success = await Services.notedbyConsideration(consi_no,state.employee_key);
                this.info = success.data
                this.GetConsideration()
                this.getnotedConsideration()
                this.ViewConsideration = false
                this.$emit("hideLoader")
            },
        }
    })
    </script>
    
    <style scoped>
    .active {
        color: #ffffff;
        background-color: #24723b;
      }
    .notactive {    
        background-color: #CCAF12;
        color: #ececec;
      }
      table tr{
        padding: 10px 10px;
      }
    </style>
    